import { DateTime } from 'luxon-business-days';

export function formatPercentage(value) {
  const parsedValue = parseFloat(value);
  return Number.isNaN(parsedValue)
    ? ''
    : new Intl.NumberFormat('en-US', { style: 'percent', minimumFractionDigits: 2 }).format(parsedValue);
}

const filters = {
  // format amount to us format
  currency(initalVal) {
    let parsedValue = parseFloat(initalVal);

    if (Number.isNaN(parsedValue)) {
      parsedValue = 0;
    }

    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
    });

    return formatter.format(parsedValue);
  },

  // format date to us format MM/DD/YYYY by default you can override it
  // eslint-disable-next-line consistent-return
  formatdate(dateStr, format = 'MM/dd/yyyy') {
    const parsedDate = DateTime.fromSQL(dateStr);

    if (parsedDate.isValid) {
      return parsedDate.toFormat(format);
    }
  },

  percentage: formatPercentage,
};

export default {
  filters,

  install(app) {
    // install all filters as global properties for Vue 3
    // eslint-disable-next-line no-param-reassign
    app.config.globalProperties.$filters = filters;
  },
};
